import type { PersistedTabContent } from 'apiConnector/tabs/tabs.model';

import type { TabsForWorkspace, WorkspaceType } from '../model';

export type WorkspaceTabContentActions =
  | WorkspaceTabContentFetchRequested
  | WorkspaceTabContentFetched
  | WorkspaceTabContentFetchFailed
  | WorkspaceTabContentPersisted
  | WorkspaceTabContentCleared;

export function workspaceTabContentFetchRequested<W extends WorkspaceType>(
  tabId: string,
  workspace: W,
  tabType: TabsForWorkspace[W],
) {
  return { type: 'WORKSPACE_TAB_CONTENT_FETCH_REQUESTED' as const, tabId, workspace, tabType };
}
export type WorkspaceTabContentFetchRequested = ReturnType<typeof workspaceTabContentFetchRequested>;

export function workspaceTabContentFetched<W extends WorkspaceType>(
  tabId: string,
  tabContent: PersistedTabContent,
  workspace: W,
  tabType: TabsForWorkspace[W],
) {
  return {
    type: 'WORKSPACE_TAB_CONTENT_FETCHED' as const,
    tabId,
    tabContent: { ...tabContent, workspace } as PersistedTabContent,
    workspace,
    tabType,
  };
}
export type WorkspaceTabContentFetched = ReturnType<typeof workspaceTabContentFetched>;

export function workspaceTabContentFetchFailed<W extends WorkspaceType>(
  tabId: string,
  workspace: W,
  error?: string,
  tabType?: TabsForWorkspace[W],
) {
  return { type: 'WORKSPACE_TAB_CONTENT_FETCH_FAILED' as const, tabId, workspace, error, tabType };
}
export type WorkspaceTabContentFetchFailed = ReturnType<typeof workspaceTabContentFetchFailed>;

export function workspaceTabContentPersisted(tabId: string, tabContent: PersistedTabContent, workspace: WorkspaceType) {
  return { type: 'WORKSPACE_TAB_CONTENT_PERSISTED' as const, tabId, tabContent, workspace };
}
export type WorkspaceTabContentPersisted = ReturnType<typeof workspaceTabContentPersisted>;

export function workspaceTabContentCleared(tabId: string, workspace: WorkspaceType) {
  return { type: 'WORKSPACE_TAB_CONTENT_CLEARED' as const, tabId, workspace };
}
export type WorkspaceTabContentCleared = ReturnType<typeof workspaceTabContentCleared>;
